import { gql } from "@apollo/client";

export default gql`
  query GetCurrentUserDashboards {
    currentUser {
      id
      currentWorkspace {
        currentAccessGroup {
          id
          dashboardAccesses {
            dashboard {
              id
              label
            }
          }
        }
      }
    }
  }
`;
